/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Layout_Add_ParentInputs */

const vi_sidebar_layout_add_parent = /** @type {(inputs: Sidebar_Layout_Add_ParentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo menu cha`)
};

/**

* @param {Sidebar_Layout_Add_ParentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sidebar_layout_add_parent = /** @type {((inputs?: Sidebar_Layout_Add_ParentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Layout_Add_ParentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sidebar_layout_add_parent(inputs)
});